import React from 'react';
import {
  IconContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ReviewsModalContainer,
} from './styles';
import { Button, IconClose, IconStarFilled } from 'takeat-design-system-ui-kit';
import { useTheme } from 'styled-components';
import { format } from 'date-fns';

export const ReviewsModal = ({ open, toggle, reviews }) => {
  const theme = useTheme();

  return (
    <ReviewsModalContainer open={open} toggle={toggle}>
      <ModalHeader>
        <h1>Avaliações</h1>
        <IconClose onClick={toggle} />
      </ModalHeader>
      <ModalContent>
        {reviews && reviews.length === 0 ? (
          <p style={{ margin: 0, textAlign: 'center' }}>
            Nenhuma avaliação disponível
          </p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Data/Hora</th>
                <th>Cliente</th>
                <th>Mesa</th>
                <th>Avaliação</th>
              </tr>
            </thead>
            <tbody>
              {reviews?.map((review, index) => (
                <tr key={index}>
                  <td>
                    {format(new Date(review.createdAt), 'dd/MM/yy - HH:mm')}
                  </td>
                  <td>{review.buyer.name}</td>
                  <td>Mesa {review.table?.table_number}</td>
                  <td>
                    <IconContainer>
                      <IconStarFilled />
                      {review.stars}
                    </IconContainer>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </ModalContent>
      <ModalFooter>
        <Button
          variant="outlined"
          customColor={theme.colors.red.default}
          onClick={toggle}
        >
          Fechar
        </Button>
      </ModalFooter>
    </ReviewsModalContainer>
  );
};
